<template>
  <div id="app">
    <!-- Header Navigation -->
    <HeaderNavigation />
    <!-- Main Content -->
    <transition name="opaque">
      <router-view />
    </transition>
    <!-- Footer Navigation -->
    <FooterNavigation />
    <!-- Internet Connection Status Toast -->
    <InternetConnectionStatusToast />
  </div>
</template>

<script>
import HeaderNavigation from "@/components/HeaderNavigation.vue";
import FooterNavigation from "@/components/FooterNavigation.vue";
import InternetConnectionStatusToast from "@/components/InternetConnectionStatusToast.vue";

export default {
  name: "App",
  components: {
    HeaderNavigation,
    FooterNavigation,
    InternetConnectionStatusToast,
  },
  mounted() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    $(".date-input").attr("min", today);
  },
};
</script>
